module.exports = __webpack_public_path__ + "media/src/img/views-icon-f8f40e996573b0e276d8a76fc4e26392.svg";